import update from 'immutability-helper';
import { createReducer } from '../modules/helpers';
import { ActionTypes } from '../constants/index';

const initState = {
  cards: {},
  status: 'init', // init -> loading -> loaded -> reloading -> loaded
  error_message: null,
};

export const paymentReducer = createReducer(initState, {
  [ActionTypes.PAYMENT_GET_REQUEST](state) {
    if (state.status === 'loading' || state.status === 'reloading') {
      return state;
    }
    if (state.status === 'init') {
      return update(state, {
        cards: { $set: {} },
        status: { $set: 'loading' },
      });
    }
    if (state.status === 'loaded') {
      return update(state, {
        status: { $set: 'reloading' },
      });
    }
    return state;
  },

  [ActionTypes.PAYMENT_GET_SUCCESS](state, { payload }) {
    return update(state, {
      cards: { $set: payload },
      status: { $set: 'loaded' },
    });
  },
  [ActionTypes.PAYMENT_GET_FAILURE](state) {
    return update(state, {
      cards: {},
      status: { $set: 'loaded' },
    });
  },

  [ActionTypes.PAYMENT_ADD_REQUEST](state) {
    return update(state, {
      status: { $set: 'loading' },
      error_message: { $set: null },
    });
  },
  [ActionTypes.PAYMENT_ADD_SUCCESS](state, { payload }) {
    return update(state, {
      cards: { $set: payload },
      status: { $set: 'loaded' },
    });
  },
  [ActionTypes.PAYMENT_ADD_FAILURE](state, { payload }) {
    return update(state, {
      status: { $set: 'loaded' },
      error_message: { $set: payload.message },
    });
  },
  [ActionTypes.PAYMENT_CLEAR_CARD_ERROR](state) {
    return update(state, {
      error_message: { $set: null },
    });
  },
  [ActionTypes.PAYMENT_PRIMARY_REQUEST](state) {
    return update(state, {
      status: { $set: 'loading' },
    });
  },
  [ActionTypes.PAYMENT_PRIMARY_SUCCESS](state, { payload }) {
    return update(state, {
      cards: { $set: payload },
      status: { $set: 'loaded' },
    });
  },
  [ActionTypes.PAYMENT_PRIMARY_FAILURE](state) {
    return update(state, {
      status: { $set: 'loaded' },
    });
  },

  [ActionTypes.PAYMENT_DELETE_REQUEST](state) {
    return update(state, {
      status: { $set: 'loading' },
    });
  },
  [ActionTypes.PAYMENT_DELETE_SUCCESS](state, { payload }) {
    return update(state, {
      cards: { $set: payload },
      status: { $set: 'loaded' },
    });
  },
  [ActionTypes.PAYMENT_DELETE_FAILURE](state) {
    return update(state, {
      status: { $set: 'loaded' },
    });
  },


});



// WEBPACK FOOTER //
// ./scripts/reducers/payment.js